import { render } from "./multiverse.vue?vue&type=template&id=ac87416c&scoped=true"
import script from "./multiverse.vue?vue&type=script&lang=js"
export * from "./multiverse.vue?vue&type=script&lang=js"

import "./multiverse.vue?vue&type=style&index=0&id=ac87416c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac87416c"]])

export default __exports__